import React from 'react';

import { MainView, HomeMain, UsersSub } from '../components/components.js';

class Home extends React.Component {


	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
		this.onSubItemClick = this.onSubItemClick.bind(this);

		this.state = {page : "main", selectedItem: {}};
	}


	onClick(e) {
		const newPage = (this.state.page === "main") ? "sub" : "main";
		this.setState({page : newPage});

	}

	onSubItemClick(e) {
		if(!e) return;
		var id = e.currentTarget.getAttribute('data-id');
		for(var i = 0; i !== this.state.zipData.length; ++i) {
			if(parseInt(this.state.zipData[i].id) === parseInt(id)) {
				this.setState({selectedItem : this.state.zipData[i]});
				return;
			}
		}
	}

	render() {
		if(window._fiSponsor.sponsors.length === 0) {
			window._fiSponsor.loadSessionInfo();
		}
		////console.log("HOME SPONSORS");
		////console.log(window._fiSponsor.sponsors);
		
		var content = (
			<p>Content not found</p>
			);
		var location = "Dashboard";
		if (this.state.page === "main") {
			content = (
		  		<HomeMain subviewClick={this.onClick} />
		  	);
		}

		else if(this.state.page === "sub") {
			location = ["Dashboard", "Zipcodes"];

			content = (
				<UsersSub />
				);
		}

		window._fiSponsor.loadSessionInfo();
		var total_saved = (window._fiSponsor.sponsors[0]) ? window._fiSponsor.sponsors[0].total_saved : '-.--';
		return (
		    <MainView location={location} amount={total_saved} content={content} />
		);
  	}
}


export default Home;